import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { SupportRequestDto } from "../core";
import { Observable } from "rxjs";
import { brdCatchError } from "../shared/message-utils";
import { environment } from "../../environments/environment";

@Injectable({
  providedIn: "root"
})
export class SupportService {
  private httpClient = inject(HttpClient);
  constructor() {}

  sendSupportRequest(request: SupportRequestDto): Observable<void> {
    return this.httpClient.post<void>(`${environment.API}/Support`, request).pipe(brdCatchError());
  }
}
